module.exports = __webpack_public_path__ + "static/media/Gotham-Black.14b3a355.otf";